import type { CrmHourPoint } from '@chatbot/shared-types';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CRM_SERIES_COLOR } from '../../lib/chart-colors.ts';
import { ChartEmpty, ChartTooltip, chartAxisProps, chartGridProps } from './chart-theme.tsx';

/** Horas pico: siempre las 24 franjas, así el eje no miente sobre huecos. */
export function PeakHoursCrmChart({
  data,
  motivoVacio,
}: {
  data: CrmHourPoint[];
  motivoVacio?: string;
}) {
  const byHour = new Map(data.map((p) => [p.hour, p.conversations]));
  const total = data.reduce((s, p) => s + p.conversations, 0);

  const chartData = Array.from({ length: 24 }, (_, hour) => ({
    label: `${String(hour).padStart(2, '0')}h`,
    conversations: byHour.get(hour) ?? 0,
  }));

  return (
    <div
      className="h-64 w-full"
      data-testid="chart-peak-hours"
      role="img"
      aria-label="Gráfico de barras con las conversaciones por hora del día, de 0 a 23"
    >
      {total === 0 ? (
        <ChartEmpty message={motivoVacio} />
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid {...chartGridProps} />
            <XAxis dataKey="label" interval={1} {...chartAxisProps} />
            <YAxis allowDecimals={false} {...chartAxisProps} />
            <Tooltip cursor={{ fillOpacity: 0.06 }} content={ChartTooltip} />
            <Bar
              dataKey="conversations"
              name="Conversaciones"
              fill={CRM_SERIES_COLOR.conversations}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
